import { render, staticRenderFns } from "./AddedChanges.vue?vue&type=template&id=7b9f2ed9&"
import script from "./AddedChanges.vue?vue&type=script&lang=js&"
export * from "./AddedChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports